<div class="flex flex-wrap mt-4">
    <div class="faceted-section w-15">
        <h3>Filtros</h3>
        <div class="faceted-filter-type-container">
            <strong>Sentimientos</strong>
            <div *ngIf="facetedData.selectedSentiment.length > 0">
                <div class="faceted-item">
                    {{facetedData.selectedSentiment}}
                    <em class="fa fa-close cursor-pointer text-gray hover:text-red"
                        (click)="facetedRemoveSentiment()"></em>
                </div>
            </div>
            <ul *ngIf="facetedData.selectedSentiment.length === 0">
                <li *ngFor="let item of facetedData.showedSentiments">
                    <div class="faceted-item cursor-pointer" (click)="facetedSelectSentiment(item.name)">
                        {{item.name}} ({{item.amount}})
                    </div>
                </li>
            </ul>
        </div>
        <div class="faceted-filter-type-container">
            <strong>Tópicos</strong>
            <div *ngIf="facetedData.selectedTopic.length > 0">
                <div class="faceted-item">
                    {{facetedData.selectedTopic}}
                    <em class="fa fa-close cursor-pointer text-gray hover:text-red" (click)="facetedRemoveTopic()"></em>
                </div>
            </div>
            <ul *ngIf="facetedData.selectedTopic.length === 0">
                <li *ngFor="let item of facetedData.showedTopics">
                    <div class="faceted-item cursor-pointer" (click)="facetedSelectTopic(item.name)">
                        {{item.name}} ({{item.amount}})
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="scroll w-84">
        <table mat-table [dataSource]="filteredDatasource">
            <ng-container matColumnDef="number">
                <th mat-header-cell *matHeaderCellDef> No </th>
                <td mat-cell *matCellDef="let element"> {{element.position}} </td>
            </ng-container>

            <ng-container matColumnDef="text">
                <th mat-header-cell *matHeaderCellDef> Texto </th>
                <td mat-cell *matCellDef="let element"> {{element.text}} </td>
            </ng-container>

            <ng-container matColumnDef="sentiment">
                <th mat-header-cell *matHeaderCellDef> Sentimiento </th>
                <td mat-cell *matCellDef="let element"> {{element.sentiment}} </td>
            </ng-container>

            <ng-container matColumnDef="wrong_sentiment">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <em class="fa fa-warning cursor-pointer text-gray hover:text-red"
                        (click)="openDialogRectifySentiment(element)"></em>
                </td>
            </ng-container>

            <ng-container matColumnDef="topic">
                <th mat-header-cell *matHeaderCellDef> Tópico </th>
                <td mat-cell *matCellDef="let element"> {{element.topic}} </td>
            </ng-container>

            <ng-container matColumnDef="wrong_topic">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                    <em class="fa fa-warning cursor-pointer text-gray hover:text-red"
                        (click)="openDialogRectifyTopic(element)"></em>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
